module.exports = __webpack_public_path__ + "static/media/play.44314760.svg";